export const TYPES_CHIPS = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  DEFAULT: "DEFAULT",
  NOW_LATER_REQUEST: "NOW_LATER_REQUEST",
  DECLINED: "DECLINED",
  PENDING: "PENDING",
  VISIT_COMPLETED: "VISIT_COMPLETED",
};
